import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup} from "@angular/forms";

interface CustomDialogModel {
  title: string,
  description: string,
  primaryLabel: string,
  secondaryLabel: string,
  withFormInput?: boolean,
  formInputPlaceholder?: string,
  formInputLabel?: string
}

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrl: './custom-dialog.component.scss'
})


export class CustomDialogComponent {

  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CustomDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CustomDialogModel, private fb: FormBuilder) {
    if (data.withFormInput) {
      this.form = this.fb.group({
        formValue: ['']
      })
    }
  }

  close(param: boolean) {
    if (param && this.data.withFormInput) {
      this.dialogRef.close({confirm: param, formValue: this.form.get('formValue')?.value});
    } else {
      this.dialogRef.close(param);
    }

  }
}
